import { render, staticRenderFns } from "./ScreenshotHistory.vue?vue&type=template&id=6b267ce4&scoped=true"
import script from "./ScreenshotHistory.vue?vue&type=script&lang=js"
export * from "./ScreenshotHistory.vue?vue&type=script&lang=js"
import style0 from "./ScreenshotHistory.vue?vue&type=style&index=0&id=6b267ce4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b267ce4",
  null
  
)

export default component.exports